import { NavLink } from "react-router-dom";
import { getUser } from "../../../config/auth";
import { canManageUsers, canSeeAudit, canValidateTasks, canManageSettings, canReviewTimeline } from "../../../config/rbac";

/* ── Logo mark ──────────────────────────────────────────── */
function TacklLogoMark({ size = 34 }) {
  return (
    <img
      src="/logo.svg"
      alt="Tackl"
      style={{ width: size, height: size, objectFit: "contain", flexShrink: 0 }}
    />
  );
}

/* ── SVG Icons ───────────────────────────────────────────── */
function Icon({ name }) {
  const s = { width: 16, height: 16, style: { flexShrink: 0 } };
  const p = { stroke: "currentColor", strokeWidth: 1.75, strokeLinecap: "round", strokeLinejoin: "round", fill: "none" };

  switch (name) {
    case "dashboard":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <rect x="3" y="3" width="7" height="7" rx="1.5" {...p} />
          <rect x="14" y="3" width="7" height="7" rx="1.5" {...p} />
          <rect x="3" y="14" width="7" height="7" rx="1.5" {...p} />
          <rect x="14" y="14" width="7" height="7" rx="1.5" {...p} />
        </svg>
      );
    case "meetings":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <rect x="3" y="4" width="18" height="18" rx="2" {...p} />
          <line x1="16" y1="2" x2="16" y2="6" {...p} />
          <line x1="8" y1="2" x2="8" y2="6" {...p} />
          <line x1="3" y1="10" x2="21" y2="10" {...p} />
        </svg>
      );
    case "tasks":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <path d="M9 11l3 3 8-8" {...p} />
          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" {...p} />
        </svg>
      );
    case "validations":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" {...p} />
          <polyline points="9 12 11 14 15 10" {...p} />
        </svg>
      );
    case "projects":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" {...p} />
        </svg>
      );
    case "departments":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <rect x="2" y="7" width="6" height="14" rx="1" {...p} />
          <rect x="9" y="2" width="6" height="19" rx="1" {...p} />
          <rect x="16" y="11" width="6" height="10" rx="1" {...p} />
        </svg>
      );
    case "users":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" {...p} />
          <circle cx="9" cy="7" r="4" {...p} />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" {...p} />
        </svg>
      );
    case "audit":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" {...p} />
        </svg>
      );
    case "profile":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" {...p} />
          <circle cx="12" cy="7" r="4" {...p} />
        </svg>
      );
    case "timeline":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" {...p} />
          <polyline points="12 6 12 12 16 14" {...p} />
        </svg>
      );
    case "settings":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="3" {...p} />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" {...p} />
        </svg>
      );
    case "team":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <circle cx="9" cy="7" r="3" {...p} />
          <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" {...p} />
          <circle cx="18" cy="8" r="2" {...p} />
          <path d="M22 21v-1.5a3 3 0 0 0-2-2.83" {...p} />
        </svg>
      );
    case "plus":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <line x1="12" y1="5" x2="12" y2="19" {...p} />
          <line x1="5" y1="12" x2="19" y2="12" {...p} />
        </svg>
      );
    default:
      return null;
  }
}

function RailLink({ to, label, icon, onClick }) {
  return (
    <NavLink
      to={to}
      title={label}
      aria-label={label}
      className={({ isActive }) => `sidebar-rail-item${isActive ? " active" : ""}`}
      onClick={onClick}
    >
      <Icon name={icon} />
    </NavLink>
  );
}

/* ── Nav item ────────────────────────────────────────────── */
function SidebarLink({ to, label, icon, disabled, onClick }) {
  if (disabled) {
    return (
      <button type="button" className="sidebar-item disabled" disabled aria-disabled="true">
        <Icon name={icon} />
        <span>{label}</span>
      </button>
    );
  }
  return (
    <NavLink
      to={to}
      className={({ isActive }) => `sidebar-item${isActive ? " active" : ""}`}
      onClick={onClick}
    >
      <Icon name={icon} />
      <span>{label}</span>
    </NavLink>
  );
}

/* ── Section divider ─────────────────────────────────────── */
function SidebarSection({ label }) {
  return (
    <div className="sidebar-section-row">
      <span className="sidebar-section">{label}</span>
    </div>
  );
}

/* ── Sidebar ─────────────────────────────────────────────── */
function TaskManagementSidebar({ isOpen, onClose, onCreateTask }) {
  const user = getUser();
  const role = user?.role || "Staff";
  const showUsers = canManageUsers(role);
  const showAudit = canSeeAudit(role);
  const showValidation = canValidateTasks(role);
  const showSettings = canManageSettings(role);
  const showTimeline = canReviewTimeline(role);
  const initial = (user?.name || user?.email || "?")[0].toUpperCase();

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}

    <aside className={`sidebar${isOpen ? " sidebar--open" : ""}`}>
      <div className="sidebar-primary-rail" aria-label="Primary navigation">
        <div className="sidebar-rail-logo">
          <TacklLogoMark size={30} />
        </div>
        <nav className="sidebar-rail-nav">
          <RailLink to="/dashboard" label="Home" icon="dashboard" onClick={onClose} />
          <RailLink to="/tasks" label="Tasks" icon="tasks" onClick={onClose} />
          <RailLink to="/projects" label="Projects" icon="projects" onClick={onClose} />
          <RailLink to="/moms" label="Meetings" icon="meetings" onClick={onClose} />
          <RailLink to="/team" label="Team" icon="team" onClick={onClose} />
        </nav>
        <div className="sidebar-rail-utilities">
          {onCreateTask && (
            <button
              type="button"
              className="sidebar-rail-item sidebar-rail-button"
              title="Create task"
              aria-label="Create task"
              onClick={() => {
                onCreateTask();
                onClose?.();
              }}
            >
              <Icon name="plus" />
            </button>
          )}
          {showSettings && (
            <RailLink to="/settings" label="Settings" icon="settings" onClick={onClose} />
          )}
          <RailLink to="/profile" label="Profile" icon="profile" onClick={onClose} />
        </div>
      </div>

      <div className="sidebar-panel">
        {/* Brand */}
        <div className="sidebar-header">
          <div className="sidebar-brand">
            <div>
              <div className="sidebar-title">Tackl Workspace</div>
              <div className="sidebar-subtitle">Teamspace</div>
            </div>
          </div>
          <button className="sidebar-close-btn" onClick={onClose} aria-label="Close menu">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          <SidebarSection label="Overview" />
          <SidebarLink to="/dashboard" label="Dashboard" icon="dashboard" onClick={onClose} />

          <SidebarSection label="Modules" />
          <SidebarLink to="/moms" label="Meetings" icon="meetings" onClick={onClose} />
          <SidebarLink to="/tasks" label="Tasks" icon="tasks" onClick={onClose} />
          {showValidation && (
            <SidebarLink to="/validations" label="Validations" icon="validations" onClick={onClose} />
          )}
          {showTimeline && (
            <SidebarLink to="/timeline-requests" label="Timeline Requests" icon="timeline" onClick={onClose} />
          )}
          <SidebarLink to="/projects" label="Projects" icon="projects" onClick={onClose} />
          <SidebarLink to="/team" label="My Team" icon="team" onClick={onClose} />

          <SidebarSection label="Administration" />
          {showUsers && (
            <SidebarLink to="/departments" label="Departments" icon="departments" onClick={onClose} />
          )}
          {showUsers && (
            <SidebarLink to="/users" label="Users & Roles" icon="users" onClick={onClose} />
          )}
          {showAudit && (
            <SidebarLink to="/audit" label="Audit Logs" icon="audit" onClick={onClose} />
          )}
          {showSettings && (
            <SidebarLink to="/settings" label="Settings" icon="settings" onClick={onClose} />
          )}
          <SidebarLink to="/profile" label="My Profile" icon="profile" onClick={onClose} />
        </nav>

        {/* Footer */}
        <div className="sidebar-footer">
          <div className="sidebar-user-row">
            <div className="sidebar-user-avatar">{initial}</div>
            <div className="sidebar-user-info">
              <div className="sidebar-user-name">
                {user?.name || user?.email?.split("@")[0] || "User"}
              </div>
              <div className="sidebar-user-role">{role}</div>
            </div>
            <span className="sidebar-beta-badge">Beta</span>
          </div>
        </div>
      </div>
    </aside>
    </>
  );
}

export default TaskManagementSidebar;
